import { createContext, useMemo, useContext } from "react";

import { useWeeklyContext } from "../global/WeeklyContext";

import { getWholeWeeksBetween, today } from "../../utils/datetime";

export const HoursLogContext = createContext(null);

export function useHoursLogContext() {
  const context = useContext(HoursLogContext);
  if (!context) {
    throw new Error(
      "useHoursLogContext must be used within an HoursLogProvider"
    );
  }
  return context;
}

export function useHoursLogCtx() {
  const { weekStart } = useWeeklyContext();

  const wholeWeeks = useMemo(
    () => getWholeWeeksBetween(weekStart, today()),
    [weekStart]
  );

  const contextValue = useMemo(
    // Memo so if another component calls it doesn't re-run context unless changed
    () => ({
      wholeWeeks,
    }),
    [wholeWeeks]
  );

  return {
    ...contextValue,
  };
}

export default useHoursLogCtx; // Export the hook as default for backward compatibility
